import comp from "./TaggedStudentDetails";
export default comp;
